const API_BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'https://travel-advisor-umber.vercel.app';
export default API_BASE_URL;